import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSetEnabled: false,

  userAccess: {
    role: null,
    userID: null,
    lastTimestamp: null,
  },
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setIsSetEnabled: (state, action) => {
      state.isSetEnabled = action.payload;
    },
    setUserAccess: (state, action) => {
      state.userAccess = {
        ...state.userAccess,
        ...action.payload,
      };
    },
    resetPermission: () => initialState,
  },
});

export const {
  setPermission,
  setIsSetEnabled,
  setLastTimestamp,
  setUserAccess,
  resetPermission,
} = permissionSlice.actions;

export default permissionSlice.reducer;

export const selectIsRoot = (state) => {
  const apiKey = localStorage.getItem("apiKey");
  return (
    state.permission.userAccess.role === "root" &&
    state.permission.userAccess.userID === apiKey
  );
};
